module.exports = __webpack_public_path__ + "static/media/kids_playing_blue.6b2ed868.png";